namespace GeniuzPOS.ReportMasterData {
    export class Report_1505Columns {
        static columnsKey = 'ReportMasterData.Report_1505';
    }
}
